// extracted by mini-css-extract-plugin
export default {"label_wrapper":"GoogleMap_label_wrapper__BMp+L","label_title":"GoogleMap_label_title__eLqDm","label_description":"GoogleMap_label_description__1LAaX"};